<panel>
	<h1>{{ pool ? pool.name : ('task-action.list-task-actions' | translate) }}</h1>
	<list-view [emptyLabel]="'list-task-actions.task-actions-list-empty-label'" class="scrollable">
		<header>{{ 'general.column.company-name' | translate }}</header>
		<header>{{ 'general.column.taskflow-template-type' | translate }}</header>
		<header>{{ 'general.column.task-action-type' | translate }}</header>
		<header defaultSort="ascending">{{ 'general.column.created' | translate }}</header>
		<header>{{ 'general.column.planneddate' | translate }}</header>
		<header align-right></header>
		<row *listData="let taskAction from taskActions" (action)="selectTaskAction(taskAction)">
			<column>{{ taskAction.taskflow?.company?.name ? taskAction.taskflow.company.name : ('general.na' | translate) }}</column>
			<column>{{ taskAction.taskflow?.title ? taskAction.taskflow.title : ('general.na'| translate) }}</column>
			<column>{{ 'enum.task-action-type.' + taskActionType[taskAction.type] | translate }}</column>
			<column>{{ taskAction.created | customDate: 'shortDate' }}</column>
			<column>{{ taskAction.plannedDate | customDate: 'shortDate' }}</column>
			<column align-right><icon type="right" (click)="gotoTaskAction(taskAction)" /></column>
		</row>
	</list-view>
</panel>
